import * as Sentry from "@sentry/nuxt";
import { useRuntimeConfig } from "#imports";
Sentry.init({
  dsn: "https://47d32a4f2e1d4176a600b339724bbd28@o4507963384791040.ingest.us.sentry.io/4508430916845568",

  enabled: useRuntimeConfig().public.sentry.enabled,

  tracesSampleRate: useRuntimeConfig().public.sentry.enabled ? 1.0 : 0,

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  integrations: [Sentry.replayIntegration()],

  // Debug mode
  debug: false,

  environment: process.env.NODE_ENV,
});
